import React from 'react';
export function Header() {
  return <div className="bg-navy text-white py-3 px-4 sticky top-0 z-50 shadow-md" data-id="element-87">
      <div className="max-w-6xl mx-auto flex justify-between items-center" data-id="element-88">
        <div className="font-heading font-bold text-lg md:text-xl tracking-wide flex items-center" data-id="element-89">
          🧠 EUREKALABS<span className="text-orange" data-id="element-90">.STORE</span>
        </div>
        <div className="hidden md:block text-sm font-medium text-white/80" data-id="element-91">
          MORE FOCUS. LESS FRUSTRATION.{' '}
          <span className="text-orange font-bold" data-id="element-92">ZERO SCREENS.</span>
        </div>
      </div>
    </div>;
}